﻿/* PDP â€” gallery + variant picker */
(function () {
  function initGallery(root) {
    const track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    const dots = root.querySelectorAll('[data-gallery-dots] [data-dot]');
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');

    function active() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function go(idx) {
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
    }
    track.addEventListener('scroll', () => {
      const idx = active();
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    if (prev) prev.addEventListener('click', () => go(Math.max(0, active() - 1)));
    if (next) next.addEventListener('click', () => go(active() + 1));
  }

  function initVariantPicker(form, root) {
    const variantsEl = root.querySelector('[data-product-json]');
    if (!variantsEl) return;
    let variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;

    const variantInput = form.querySelector('[data-variant-id]');
    const priceWrap = root.querySelector('[data-price]');
    const atc = form.querySelector('[data-add-to-cart]');
    const atcText = form.querySelector('[data-atc-text]');
    const initialVariant = variants.find((v) => String(v.id) === String(variantInput?.value)) || variants[0];

    function variantFromId(id) {
      return variants.find((v) => String(v.id) === String(id)) || null;
    }

    function selectedOptions() {
      const baseVariant = variantFromId(variantInput?.value) || initialVariant || variants[0];
      const opts = baseVariant && Array.isArray(baseVariant.options) ? [...baseVariant.options] : [];
      const inputs = form.querySelectorAll('input[name^="options["][data-option-input]:checked');
      inputs.forEach((input) => {
        const optionIndex = parseInt(input.dataset.optionInput, 10) - 1;
        if (optionIndex >= 0) opts[optionIndex] = input.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
    }
    function updateLabels() {
      // For each option group, update the selected value display + active states
      const groups = form.querySelectorAll('[name^="options["]');
      const seen = new Set();
      groups.forEach((input) => {
        const groupName = input.name;
        if (seen.has(groupName)) return;
        seen.add(groupName);
        // Active class on parent label
        form.querySelectorAll(`[name="${groupName}"]`).forEach((i) => {
          const label = i.closest('label');
          if (label) label.classList.toggle('is-active', i.checked);
        });
      });
    }
    function update() {
      const opts = selectedOptions();
      const variant = findVariant(opts);
      updateLabels();

      if (!variant) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = 'No disponible';
        return null;
      }
      if (variantInput) variantInput.value = variant.id;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Update price
      if (priceWrap) {
        const money = (cents) => {
          const n = (cents / 100).toFixed(2).replace('.', ',');
          return `${n} €`;
        };
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWrap.innerHTML = `<span class="pdp__price-sale">${money(variant.price)}</span><span class="pdp__price-compare">${money(variant.compare_at_price)}</span>`;
        } else {
          priceWrap.innerHTML = `<span class="pdp__price-regular">${money(variant.price)}</span>`;
        }
      }

      if (variant.available) {
        if (atc) atc.disabled = false;
        if (atc) atc.classList.remove('is-sold-out');
        if (atcText) atcText.textContent = 'Añadir a la cesta';
      } else {
        if (atc) atc.disabled = true;
        if (atc) atc.classList.add('is-sold-out');
        if (atcText) atcText.textContent = 'Agotado';
      }
      return variant;
    }

    form.addEventListener('change', (e) => {
      if (e.target.matches('input[name^="options["]')) update();
    });
    form.addEventListener('input', (e) => {
      if (e.target.matches('input[name^="options["]')) update();
    });
    form.addEventListener('click', (e) => {
      const label = e.target.closest('label');
      const input = label?.querySelector('input[name^="options["][data-option-input]');
      if (!input || input.disabled) return;
      requestAnimationFrame(update);
    });
    form.addEventListener('submit', () => {
      update();
    }, true);
    form.addEventListener('formdata', (event) => {
      const variant = update();
      if (variant) event.formData.set('id', String(variant.id));
    });
    update();
  }

  function initSizeGuideModal(root) {
    const modal = root.querySelector('[data-size-guide-modal]');
    if (!modal) return;
    if (modal.dataset.modalInit === 'true') return;
    modal.dataset.modalInit = 'true';

    const openButtons = root.querySelectorAll('[data-size-guide-open]');
    const closeButtons = modal.querySelectorAll('[data-size-guide-close]');

    const closeModal = () => {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };

    const openModal = () => {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        openModal();
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function syncCrosssellGroupState(scope) {
    const root = scope.matches && scope.matches('.pdp__crosssell-form') ? [scope] : scope.querySelectorAll('.pdp__crosssell-form');
    root.forEach((crosssellForm) => {
      const radios = crosssellForm.querySelectorAll('[data-crosssell-option-input]');
      if (!radios.length) return;
      const hiddenVariantInput = crosssellForm.querySelector('[data-crosssell-variant-id]');
      radios.forEach((radio) => {
        const label = radio.closest('label');
        if (label) label.classList.toggle('is-active', radio.checked);
        if (radio.checked && hiddenVariantInput) {
          hiddenVariantInput.value = getCrosssellVariantId(crosssellForm);
        }
      });
    });
  }

  function getCrosssellVariantId(crosssellItem) {
    const hiddenVariantInput = crosssellItem.querySelector('[data-crosssell-variant-id]');
    const checkedRadio = crosssellItem.querySelector('[data-crosssell-option-input]:checked');
    if (!checkedRadio) return hiddenVariantInput?.value || '';

    const variantsEl = crosssellItem.querySelector('[data-crosssell-variants]');
    if (variantsEl) {
      try {
        const variants = JSON.parse(variantsEl.textContent);
        const initialVariant = variants.find((v) => String(v.id) === String(hiddenVariantInput?.value)) || variants[0];
        const opts = initialVariant && Array.isArray(initialVariant.options) ? [...initialVariant.options] : [];
        const optionIndex = parseInt(checkedRadio.dataset.optionIndex, 10);
        if (optionIndex >= 0) opts[optionIndex] = checkedRadio.value;
        const matchingVariant = variants.find((variant) => variant.options.every((opt, idx) => opt === opts[idx]));
        if (matchingVariant) return String(matchingVariant.id);
      } catch (err) {
        console.error('[crosssell] variant lookup failed', err);
      }
    }

    return checkedRadio.dataset.variantId || hiddenVariantInput?.value || '';
  }

  async function submitCrosssellForm(crosssellItem) {
    const hiddenVariantInput = crosssellItem.querySelector('[data-crosssell-variant-id]');
    const variantId = getCrosssellVariantId(crosssellItem);
    if (!variantId) return;
    if (hiddenVariantInput) {
      hiddenVariantInput.value = variantId;
    }
    if (crosssellItem.dataset.crosssellAdding === 'true') return;
    crosssellItem.dataset.crosssellAdding = 'true';
    try {
      const data = new FormData();
      data.append('id', variantId);
      data.append('quantity', '1');
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      });
      if (!r.ok) throw new Error('add failed: ' + r.status);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.refresh === 'function') {
        await drawer.refresh();
        document.querySelector('cart-drawer')?.open();
      }
    } catch (err) {
      console.error('[crosssell] add to cart failed', err);
    } finally {
      delete crosssellItem.dataset.crosssellAdding;
    }
  }

  function initCrosssellVariantPickers(root) {
    syncCrosssellGroupState(root);
    if (root.dataset.crosssellVariantInit === 'true') return;
    root.dataset.crosssellVariantInit = 'true';
    root.addEventListener('change', (event) => {
      if (!event.target.matches('[data-crosssell-option-input]')) return;
      const crosssellForm = event.target.closest('.pdp__crosssell-form');
      if (!crosssellForm) return;
      syncCrosssellGroupState(crosssellForm);
      if (crosssellForm.hasAttribute('data-crosssell-auto-add')) {
        submitCrosssellForm(crosssellForm);
      }
    });
    root.addEventListener('click', (event) => {
      const label = event.target.closest('label.pdp__crosssell-size');
      if (!label) return;
      const input = label.querySelector('[data-crosssell-option-input]');
      if (!input || input.disabled || !input.checked) return;
      const crosssellForm = label.closest('.pdp__crosssell-form');
      if (!crosssellForm || !crosssellForm.hasAttribute('data-crosssell-auto-add')) return;
      submitCrosssellForm(crosssellForm);
    });
    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-crosssell-add]');
      if (!button) return;
      const crosssellForm = button.closest('.pdp__crosssell-form');
      if (!crosssellForm) return;
      submitCrosssellForm(crosssellForm);
    });
  }

  function init() {
    const sections = document.querySelectorAll('.pdp');
    sections.forEach((root) => {
      initGallery(root);
      const form = root.querySelector('[data-pdp-form]');
      if (form) initVariantPicker(form, root);
      initSizeGuideModal(root);
      initCrosssellVariantPickers(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
